function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "delete_backspace"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m20.004 5h-11c-.837 0-1.852.452-2.412 1.074l-4.062 4.514c-.712.792-.712 2.032 0 2.824l4.062 4.514c.56.622 1.575 1.074 2.412 1.074h11c1.103 0 2-.897 2-2v-10c0-1.103-.898-2-2-2zm-.003 12h-10.997c-.265 0-.749-.216-.926-.412l-4.062-4.514c-.026-.028-.026-.12 0-.148l4.063-4.514c.176-.196.661-.412.925-.412h11z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m11.297 14.707c.196.195.452.293.707.293s.512-.098.707-.293l1.292-1.293 1.293 1.293c.196.195.452.293.708.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-1.293-1.293 1.293-1.293c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-1.293 1.293-1.292-1.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l1.292 1.293-1.293 1.293c-.39.391-.39 1.023 0 1.414z"
})));

var Svg039Backspace = function Svg039Backspace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg039Backspace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/039-backspace.4b37d7ee.svg";
export { ForwardRef as ReactComponent };